import { format, parseISO } from "date-fns";
import { useParams } from "react-router-dom";

import { useGetReimbursementExport } from "~/providers/hooks";
import { getFullName, PatientParams } from "~/providers/utils";
import { PdfDownloadLink } from "../shared/PdfDownloadLink";
import { ReimbursementExportDocument } from "./ReimbursementExportDocument";

export const ReimbursementExportDownloadLink = () => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;
  const { data, isLoading } = useGetReimbursementExport({ patientId });

  if (isLoading || !data) return null;

  const patientName = getFullName(data.patient.name, data.patient.last_name);
  const completedAt = data.report.completed_at
    ? format(parseISO(data.report.completed_at), `MM_d_yyyy`)
    : "";

  const pdfData = {
    patient: data.patient,
    noteData: data.report.data,
    completedAt: data.report.completed_at,
    completedBy: data.report.completed_by,
    basicPatientInformation: data.basicPatientInformation,
    actualStartTime: data.actualStartTime,
    actualEndTime: data.actualEndTime,
  };

  return (
    <PdfDownloadLink
      document={<ReimbursementExportDocument data={pdfData} />}
      fileName={`Psychiatric consultation - ${patientName} - ${completedAt}.pdf`}
    />
  );
};
